import { Container, makeStyles } from "@material-ui/core";
import ValueCard from '../../PageElements/ValueCard/ValueCard';
import CommentsCard from '../CommentsCard/CommentsCard';

function CardsGridForValue() {

  const useStyles = makeStyles({
    root: {
      "@media (max-width: 720px)": {

        flexDirection:"column"
      },
      "@media (min-width: 1150px)": {
        display: 'flex',
        position: 'center'
      },
    },
  });

  const classes = useStyles();

  return (
    <Container className={classes.root} id="values">
      <ValueCard text="Concretização da capacidade postulatória da mulher em situação de violência doméstica" />
      <ValueCard text="Agilidade e eficiência no acesso à justiça e aos serviços públicos especializados" />
      <ValueCard text="Automatização do pedido de medida protetiva e envio automático para o tribunal" />
    </Container>
  );
}

function CardsGridForComments() {

  const useStyles = makeStyles({
    root: {
      "@media (max-width: 576px)": {
        flexDirection:"column"
      },
      "@media (max-width: 720px)": {
        flexDirection:"column"
      },
      "@media (max-width: 1150px)": {
        flexDirection:"column"
      },
      "@media (max-width: 1300px)": {
        flexDirection:"column"
      },
      display: "flex",
    },
  });

  const classes = useStyles();

  return (
    <Container className={classes.root} id="values">
      <CommentsCard text="“Vale a pena procurar o aplicativo e acreditar que é possível mudar a situação ao denunciar. É um instrumento que dá todo o suporte necessário à vítima. Eu achei que não adiantaria nada, mas me surpreendi pelo retorno rápido. Hoje vivo em paz com meus filhos.”" />
      <CommentsCard text="“Fiquei sabendo do aplicativo através de uma reportagem e, agora,  após ter usado esse socorro, me sinto mais segura com a intimação dele (ex-companheiro). Tomei coragem em denunciar a violência psicológica que sofri durante 10 anos de relacionamento. Descobri que meu telefone tinha sido rastreado por ele para acompanhar todos os meus passos, além das ameaças na frente da nossa filha. Isso gerou um transtorno de ansiedade. Até hoje preciso tomar medicamento controlado. Eu gostei muito do aplicativo, foi meu primeiro contato com o Judiciário.”" />
    </Container>
  );
}

export { CardsGridForValue, CardsGridForComments };